<template>
    <b-modal
        id="checkoutModal"
        v-model="schimbaModal"
        size="xl"
        ok-variant="success"
        ok-title="Confirmă"
        cancel-variant="danger"
        cancel-title="Anulează"
        header-bg-variant="dark"
        body-bg-variant="dark"
        hide-footer
        hide-header
        centered
        @hide="$emit('hideTempModal');onHide($event)"
    >

        <div class="modal-body">
            <div class="close-button" @click="$emit('hideTempModal')">X</div>
            <div class="modal-header">
                <span>{{ tutorialName }}</span>
            </div>
            <div class="videoWrapper">
                <iframe :src="tutorial" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import {BModal, BForm, BFormGroup, BFormInput, BButton, BIconTrash, BFormTextarea, BFormFile, BIconUpload} from 'bootstrap-vue';
    import vSelect from 'vue-select'
    export default {
        components: {
            BModal,
            BForm,
            BFormGroup,
            BFormInput,
            BButton,
            BIconTrash,
            BFormTextarea,
            BFormFile,
            BIconUpload,
            vSelect
        },
        props: {
            schimbaModal: {
                type: Boolean,
                default: false
            },
            tutorialName: {
                type: String,
                default: ''
            },
            tutorial: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
            };
        },
        mounted() {
        },
        methods: {
            onHide(evt) {
                if(evt.trigger === "backdrop"){
                    evt.preventDefault();
                    this.$emit('hideTempModal')
                }
            },
        },
    };
</script>

<style scoped>
.modal-body{
    display: flex;
    flex-direction: column;
    align-items: center;
}
.modal-body >>> .modal-header span {
    font-size: 22px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 30px;
}
.modal-body >>> .modal-header {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    position: relative;
}
.modal-body p{
    color: #fff;
    text-align: center;
    margin-top: 15px;
}
.close-button{
    position: absolute;
    right: 0;
    top: 0;
    font-size: 11px;
    line-height: 1;
    font-weight: 600;
    color: #000;
    background: #fff;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.videoWrapper{
    position: relative;
    padding-bottom: 56.2%; /* 16:9 */
    height: 0;
    width: 100%;
}
iframe{
    position: absolute;
    top: 0;
    left: 0;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
}
</style>
